/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import Joi from 'joi';

export const schemaWithRequiredCaptcha = Joi.object({
    orderNumber: Joi.string()
        .trim()
        .regex(/^W?\d{7,30}$/i) // this regex will recieve order number with W or without min length 8 max is 30
        .min(7)
        .max(30)
        .required()
        .messages({
            'string.empty': 'Order Number is required.',
            'string.pattern.base': 'Invalid order number format.',
            'string.min': 'Order Number should be at least {#limit} characters.',
            'string.max': 'Order Number should not exceed {#limit} characters.',
        })
        .label('Order Number'),
    zipCode: Joi.string()
        .trim()
        .min(5)
        .max(10)
        .required()
        .custom((value, helpers) => {
            const [{ zipCode }] = helpers.state.ancestors;

            const regexUSA = /^[0-9]{5}(?:-[0-9]{4})?$/;
            const regexCAN = /^[a-zA-Z0-9]*\s*[a-zA-Z0-9][a-zA-Z0-9\s]*$/


            if (!(zipCode.match(regexUSA) || zipCode.match(regexCAN))) {
                return helpers.error('string.pattern.base', {
                    custom: {
                        message: 'Invalid Zip Code',
                    }
                });
            }

            return value;
        })
        .messages({
            'string.empty': 'Recipient Zip Code is required.',
            'string.pattern.base': '{{#custom.message}}',
            'string.min': 'Recipient Zip Code should be at least {#limit} characters.',
            'string.max': 'Recipient Zip Code should not exceed {#limit} characters.',
        })
        .label('Recipient Zip Code'),
    billingZipCode: Joi.string()
        .trim()
        .min(5)
        .max(10)
        .required()
        .custom((value, helpers) => {
            const [{ billingZipCode }] = helpers.state.ancestors;
            const regexUSA = /^[0-9]{5}(?:-[0-9]{4})?$/;
            const regexCAN = /^[a-zA-Z0-9]*\s*[a-zA-Z0-9][a-zA-Z0-9\s]*$/


            if (!(billingZipCode.match(regexUSA) || billingZipCode.match(regexCAN))) {
                return helpers.error('string.pattern.base', {
                    custom: {
                        message: 'Invalid Zip Code',
                    }
                });
            }

            return value;
        })
        .messages({
            'string.empty': 'Billing Zip Code is required.',
            'string.pattern.base': '{{#custom.message}}',
            'string.min': 'Billing Zip Code should be at least {#limit} characters.',
            'string.max': 'Billing Zip Code should not exceed {#limit} characters.',
        })
        
        .label('Billing Zip Code'),
    recaptcha: Joi.string()
        .messages({
            'string.required': 'Please confirm you are not a bot.',
            'any.required': 'Please confirm you are not a bot.',
            'string.empty': 'Please confirm you are not a bot.',
        })
        .required()
        .label('recaptcha'),
});

export const schemaWithOptionalCaptcha = Joi.object({
    orderNumber: Joi.string()
        .trim()
        .regex(/^W?\d{7,30}$/i) // this regex will recieve order number with W or without min length 8 max is 30
        .min(7)
        .max(30)
        .required()
        .messages({
            'string.empty': 'Order Number is required.',
            'string.pattern.base': 'Invalid order number format.',
            'string.min': 'Order Number should be at least {#limit} characters.',
            'string.max': 'Order Number should not exceed {#limit} characters.',
        })
        .label('Order Number'),
    zipCode: Joi.string()
        .trim()
        .regex(/^[0-9]{5}(?:-[0-9]{4})?$/) // 12345 || 12345-6789 = true
        .min(5)
        .max(10)
        .required()
        .messages({
            'string.empty': 'Recipient Zip Code is required.',
            'string.pattern.base': 'Recipient Zip Code should match the pattern: 12345 or 12345-6789.',
            'string.min': 'Recipient Zip Code should be at least {#limit} characters.',
            'string.max': 'Recipient Zip Code should not exceed {#limit} characters.',
        })
        .label('Recipient Zip Code'),
    billingZipCode: Joi.string()
        .trim()
        .regex(/^[0-9]{5}(?:-[0-9]{4})?$/) // 12345 || 12345-6789 = true
        .min(5)
        .max(10)
        .messages({
            'string.empty': 'Billing Zip Code is required.',
            'string.pattern.base': 'Billing Zip Code should match the pattern: 12345 or 12345-6789.',
            'string.min': 'Billing Zip Code should be at least {#limit} characters.',
            'string.max': 'Billing Zip Code should not exceed {#limit} characters.',
        })
        .required()
        .label('Billing Zip Code'),
    recaptcha: Joi.any()
        .optional(),
});
